import React, { useEffect, useRef } from 'react';
import { Message, MessageProps } from './Message';
import { copy } from '../../copy';
interface ThreadProps {
  messages: MessageProps[];
}
export function Thread({
  messages
}: ThreadProps) {
  const bottomRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    bottomRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  }, [messages]);
  return <div className="flex flex-col w-full bg-white dark:bg-[#1a1a1a]" data-id="element-69">
      {messages.length === 0 ? <div className="flex flex-col items-center justify-center py-24 text-center" data-id="element-70">
          <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-50 dark:bg-[#222] border border-slate-100 dark:border-[#333] shadow-sm" data-id="element-71">
            <span className="text-2xl" data-id="element-72">✨</span>
          </div>
          <h1 className="text-2xl font-semibold text-slate-900 dark:text-white" data-id="element-73">
            {copy.thread.emptyTitle}
          </h1>
          <p className="mt-2 text-slate-500 dark:text-[#a3a3a3] max-w-sm" data-id="element-74">
            {copy.thread.emptyBody}
          </p>
        </div> : messages.map((msg, index) => <Message key={index} role={msg.role} content={msg.content} steps={msg.steps} sources={msg.sources} data-id="element-75" />)}
      <div ref={bottomRef} className="h-4" data-id="element-76" />
    </div>;
}